import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import SdsTextField from '@/components/SdsTextField.vue';
import SdsDateRangeField from '@/components/SdsDateRangeField.vue';
import { mdiInformation } from '@mdi/js';
import { usePublicoParecerReferencialStore } from '../store/PublicoParecerReferencialStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardMaisFiltros',
  setup(__props) {

const store = usePublicoParecerReferencialStore();
const { filter } = storeToRefs(store);

return { __sfc: true,store, filter, CardExpand, SdsTextField, SdsDateRangeField, mdiInformation }
}

})